module.exports = __webpack_public_path__ + "img/01.6700a486.png";